export class RestoreAtlasClusterInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "restoreAccountId",
            "baseName": "restoreAccountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusterName",
            "baseName": "clusterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "allowExistingCluster",
            "baseName": "allowExistingCluster",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "databasePrefix",
            "baseName": "databasePrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseFilter",
            "baseName": "databaseFilter",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreAtlasClusterInput.attributeTypeMap;
    }
    constructor() {
    }
}
